import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import {FOTO_SISWA_APP_HOST, SERVER_API} from "../../constants/siteConfig";

class Media extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataMedia       : [],
            kelas_id        : "",
            user_foto_id    : "",
            user_nama       : "",
            kelas_nama      : "",
            urlZip          : "",
            isButtonLoading : false,
            isLoading       : false,
            redirect        : false,
        }

        this.handleSubmit = this.handleSubmit.bind(this)
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            kelas:this.props.match.params.kelas_id,
		});

        axios({
            method: 'post',
            url: '/kelas/media?' + params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {

                this.setState({
                    dataMedia : result.data,
                    kelas_nama : result.kelas,
                    isLoading : false 
                })
                
            }   
            else {

                Alert.error(result.message)
                this.setState({ isLoading : false })
            }                    

        })
        .catch((error) => {
 
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
        
    }
    
    handleSubmit(){

        this.setState({isButtonLoading: true});

        axios({
            method: 'get',
            url: '/kelas/download/' + this.props.match.params.kelas_id
        })
        .then((response) => {
            const result = response.data

            if(result.success === true){

                this.setState({
                    redirect: true,
                    isButtonLoading : false,
                    urlZip : result.data,
                })


                if(this.state.redirect === true){
                    const newwindow = window.open(SERVER_API +this.state.urlZip, '_blank');
                    newwindow.focus();
                }

                Alert.success(result.message);
            }
            else{
                this.setState({ isButtonLoading:false })
                Alert.error(result.message)
            }

        })
        .catch((error) => {
            console.log(error)
            this.setState({ isButtonLoading : false })
            Alert.error("Data gambar tidak ditemukan !")
            
        })
    }

    componentDidMount() {

        this.loadData()
    }
    
    render() {
        
        return (
            <div className="col-sm-12">                
                <div className="card">

                    <div className="card-header" style={{verticalalign: "middle", paddingTop: "20px"}}>
                        {this.props.mode} Siswa Kelas - { this.state.kelas_nama }

                        <button 
                            type="button"
                            className="btn btn-primary pull-right"
                            onClick={this.handleSubmit}
                        >
                            Download Media
                        </button>

                    </div>

                    <div className="card-block">
                    {
                        this.state.isLoading ? (  
                            'Memuat Data...' 
                        ) : this.state.dataMedia.length === 0 ? (
                            "Belum ada media siswa..."
                        ) : (
                            <div className="col-md-12">

                                {this.state.dataMedia.map((item) => {
                                    return(
                                        <div key={item.user_id} className="col-md-3" style={{display:'inline-block'}}>
                                            {item.user_nama === null ? "Data tidak tersedia" :
                                                <img
                                                    src={
                                                        item.user_foto_id !== null ? FOTO_SISWA_APP_HOST+item.user_foto_id : ""
                                                    }
                                                    title={item.user_nama}
                                                    alt={item.user_nama}
                                                    style={{ width: "100%", maxHeight: "420px", paddingBottom: "20px" }}
                                                />
                                                
                                            }
                                        </div>         
                                    )
                                })}

                            </div>
                        
                        )
                    }                    
                    </div>

                </div>
            </div>
        );
    }
}

export default Media;


// WEBPACK FOOTER //
// ./src/views/Kelas/Media.js